import { removeNonAlpha } from 'utilities/removeNonAlpha';

/**
 * Get the initials from a name.
 * @param {string} name - The name to get the initials from.
 * @param {number} [maxInitials=2] - The maximum number of initials to return.
 * @returns {string} The initials of the name.
 */ 

interface GetInitialsParams {
  name: string;
  maxInitials?: number;
}

const getInitials = ({name, maxInitials = 2}: GetInitialsParams): string => {
  const cleanedName: string = removeNonAlpha(name);
  const nameParts: string[] = cleanedName.split(' ');
  if (nameParts.length === 1) {
    return nameParts[0].charAt(0).toUpperCase();
  }
  const initials: string = nameParts
    .map((part: string) => part.charAt(0).toUpperCase())
    .slice(0, maxInitials)
    .join('');
  return initials;
};

export default getInitials;
